const ACCESS_CHANGED_KEY = 'drawonamap:account-access-changed:v1';

/** Notify other tabs to read server access. The message itself grants no access. */
export function notifyAccountAccessChanged(): void {
  try { localStorage.setItem(ACCESS_CHANGED_KEY, crypto.randomUUID()); }
  catch { /* Tabs also read account access when they become visible or focused. */ }
}

export function installAccountAccessRefresh(refresh: (options?: { force?: boolean }) => Promise<void>): () => void {
  const controller = new AbortController();
  const options = { signal: controller.signal };
  window.addEventListener('online', () => { void refresh({ force: true }); }, options);
  window.addEventListener('storage', event => {
    if (event.key === ACCESS_CHANGED_KEY) void refresh({ force: true });
  }, options);
  window.addEventListener('focus', () => { void refresh(); }, options);
  window.addEventListener('pageshow', () => { void refresh(); }, options);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') void refresh();
  }, options);
  return () => controller.abort();
}
